import React from 'react'
import AnnoFestivo from './AnnoFestivo'


const ListadoFestivos = (props) => {
   

  return (
    <>  
         <AnnoFestivo anno={props.anno} centroId={props.centroId} update={props.update}></AnnoFestivo>
    </>
  )
}

export default ListadoFestivos